/**
 * BTableFormContext
 * @author Tevin
 */

import React from 'react';

export const BTableFormContext = React.createContext('TableForm');
